import { createApiHook } from '../hooks';
import { onboardingApiFactory } from './onboardingApiFactory';

export const useOnboardingApi = createApiHook(onboardingApiFactory);
